import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { BadgeCheck, ShieldCheck, ArrowRight, Check } from "lucide-react";
import { Button } from "../ui/button";
import { useModals } from "./ModalProvider";

export default function ComplianceDetailModal({ item, onOpenChange }) {
  const { openBookConsultation } = useModals();
  const open = !!item;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl p-0 overflow-hidden" data-testid="compliance-detail-modal">
        {item && (
          <>
            <div className="relative bg-gradient-to-br from-primary via-primary to-[#0a3560] text-white p-6 sm:p-7 overflow-hidden">
              <div className="absolute -top-20 -right-20 h-56 w-56 rounded-full bg-secondary/30 blur-3xl" />
              <div className="absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-accent/30 blur-3xl" />
              <div className="relative">
                <div className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-widest">
                  <BadgeCheck className="h-3 w-3" /> {item.scope}
                </div>
                <DialogHeader className="mt-3 text-left">
                  <DialogTitle className="font-display text-3xl sm:text-4xl font-black tracking-tight text-white">
                    {item.code}
                  </DialogTitle>
                  <p className="mt-1 text-sm font-semibold uppercase tracking-widest text-white/80">
                    {item.subtitle}
                  </p>
                </DialogHeader>
              </div>
            </div>

            <div className="p-6 sm:p-7">
              <DialogDescription className="text-sm sm:text-base leading-relaxed text-foreground/90">
                {item.desc}
              </DialogDescription>

              <div className="mt-5">
                <div className="text-xs font-bold uppercase tracking-widest text-primary flex items-center gap-1.5">
                  <ShieldCheck className="h-3.5 w-3.5" /> What Techmate delivers
                </div>
                <ul className="mt-3 space-y-2">
                  {item.highlights?.map((h) => (
                    <li key={h} className="flex items-start gap-3 rounded-xl border border-border bg-card p-3">
                      <div className="h-6 w-6 rounded-md bg-primary/10 text-primary grid place-items-center shrink-0">
                        <Check className="h-3.5 w-3.5" strokeWidth={3} />
                      </div>
                      <span className="text-sm text-foreground/90">{h}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Button
                data-testid="compliance-detail-consult-btn"
                onClick={() => { onOpenChange(false); openBookConsultation(); }}
                className="mt-6 w-full bg-primary hover:bg-primary/90 rounded-full h-11"
              >
                Discuss with a consultant <ArrowRight className="ml-1.5 h-4 w-4" />
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
